import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { GettenantComponent } from './gettenant.component';
import { TenantMyAccountComponent } from './tenant-my-account/tenant-my-account.component';


const routes: Routes = [
  {
    path: 'my-account',
    component: TenantMyAccountComponent
  },
  {
    path: ':id',
    component: GettenantComponent
  },
  {
    path: '',
    component: GettenantComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GettenantRoutingModule {
}
